import { createAction, createReducer } from '@reduxjs/toolkit';

import { type SnackbarMessage } from '../../components/ConsecutiveSnackbars.js';
import { type Event } from '../../models/index.js';

export interface CommonState {
  patientsProfiles: {
    [key: string]: {
      isVideoPlaying?: boolean;
      emergencyInProgress?: Event;
    };
  };
  colorMode: 'light' | 'dark';
  snackPack: readonly SnackbarMessage[];
}

const commonState: CommonState = {
  patientsProfiles: {},
  colorMode: 'light',
  snackPack: [],
};

export const addSnackPack = createAction<{ message: string; error: boolean }>('common/addSnackPack');
export const removeShownSnackPack = createAction('common/removeShownSnackPack');
export const toggleIsVideoPlaying = createAction<string>('common/toggleIsVideoPlaying');
export const toggleEmergencyInProgress = createAction<{ patientId: string; event?: Event }>(
  'common/toggleEmergencyInProgress',
);
export const toggleColorMode = createAction('common/toggleColorMode');
export const setColorMode = createAction<'dark' | 'light'>('common/setColorMode');
const commonReducer = createReducer(commonState, (builder) => {
  builder
    .addCase(toggleIsVideoPlaying, (state, { payload: patientId }) => {
      if (typeof state.patientsProfiles[patientId]?.isVideoPlaying !== 'undefined') {
        state.patientsProfiles[patientId].isVideoPlaying = !state.patientsProfiles[patientId].isVideoPlaying;
      } else {
        state.patientsProfiles[patientId] = {
          ...state.patientsProfiles[patientId],
          isVideoPlaying: false,
        };
      }
    })
    .addCase(toggleEmergencyInProgress, (state, { payload: { patientId, event } }) => {
      if (typeof state.patientsProfiles[patientId]?.emergencyInProgress !== 'undefined') {
        state.patientsProfiles[patientId].emergencyInProgress = event;
      } else {
        state.patientsProfiles[patientId] = {
          ...state.patientsProfiles[patientId],
          emergencyInProgress: event,
        };
      }
    })
    .addCase(toggleColorMode, (state) => {
      state.colorMode = state.colorMode === 'light' ? 'dark' : 'light';
    })
    .addCase(setColorMode, (state, { payload: mode }) => {
      state.colorMode = mode;
    })
    .addCase(addSnackPack, (state, { payload: { message, error } }) => {
      state.snackPack = [...state.snackPack, { message, key: new Date().getTime(), error }];
    })
    .addCase(removeShownSnackPack, (state) => {
      if (state.snackPack.length) {
        state.snackPack = state.snackPack.slice(1);
      }
    });
});

export default commonReducer;
